import { Options } from '@/components/Controls/Select';
import { TFunction } from 'i18next';
import { EntityFilterSelect, FilterEntity, FilterGrid } from './FilterKit';

type UserFilterProps = {
  t: TFunction<undefined>;
  isLoadingAllGroups?: boolean;
  isLoadingAllCompanies?: boolean;
  isLoadingAllBranches?: boolean;
  groupOptions?: Options[];
  companyOptions?: Options[];
  branchOptions?: Options[];
  displayGroupFilter?: boolean;
  displayCompanyFilter?: boolean;
  displayBranchFilter?: boolean;
  groupId?: string;
  companyId?: string;
  branchId?: string;
  searchByGroup?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  searchByCompany?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  searchByBranch?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
};

const UserFilter = ({
  t,
  isLoadingAllGroups,
  isLoadingAllCompanies,
  isLoadingAllBranches,
  groupOptions,
  companyOptions,
  branchOptions,
  displayGroupFilter,
  displayBranchFilter,
  displayCompanyFilter,
  groupId,
  companyId,
  branchId,
  searchByGroup,
  searchByCompany,
  searchByBranch,
}: UserFilterProps) => {
  return (
    <FilterGrid>
      {displayGroupFilter && (
        <EntityFilterSelect
          entity={FilterEntity.GROUP}
          label={t('common:linkedToGroup')}
          options={groupOptions}
          value={groupId}
          loading={isLoadingAllGroups}
          onChange={searchByGroup}
        />
      )}
      {displayCompanyFilter && (
        <EntityFilterSelect
          entity={FilterEntity.COMPANY}
          label={t('common:linkedToCompany')}
          options={companyOptions}
          value={companyId}
          loading={isLoadingAllCompanies}
          emptyMessage={
            groupId
              ? t('common:noCompanyLinkedToThisGroup')
              : t('common:youAreNotLinkedToAnyCompany')
          }
          onChange={searchByCompany}
        />
      )}
      {displayBranchFilter && (
        <EntityFilterSelect
          entity={FilterEntity.BRANCH}
          label={t('common:linkedToBranch')}
          options={branchOptions}
          value={branchId}
          loading={isLoadingAllBranches}
          emptyMessage={
            companyId
              ? t('common:noBranchLinkedToThisCompany')
              : groupId
                ? t('common:noBranchLinkedToThisGroup')
                : t('common:youAreNotLinkedToAnyBranch')
          }
          onChange={searchByBranch}
        />
      )}
    </FilterGrid>
  );
};

export default UserFilter;
